import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormElementUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormElementUpdate = createAsyncThunk(
    'formElementUpdate/fetchFormElementUpdate',
    async ({ id, file, element, type, formId }) => {
        const response = await FormElementUpdateService(id, file, element, type, formId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const formElementUpdateSlice = createSlice({
    name: 'formElementUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormElementUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormElementUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormElementUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formElementUpdateSlice.reducer;
